import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = [ "checkbox", "naPanel", "notePanel", "naReason", "note", "naToggle", "noteToggle" ]

  toggle() {
    if (this.checkboxTarget.disabled) return

    this.naPanelTarget.classList.add("hidden")

    if (this.checkboxTarget.checked) {
      this.patchItem({
        "qc_checklist_item[checked]": "1",
      })
    } else {
      if (this.naReasonTarget.value.trim() !== "" && !this.naPanelTarget.classList.contains("hidden")) {
        this.patchItem({
          "qc_checklist_item[checked]": "0",
          "qc_checklist_item[not_applicable]": "1",
          "qc_checklist_item[na_reason]": this.naReasonTarget.value,
        })
      } else {
        this.patchItem({
          "qc_checklist_item[checked]": "0",
        })
      }
    }

  }

  toggleNa(event) {
    event.preventDefault()
    const showing = !this.naPanelTarget.classList.contains("hidden")
    if (showing) {
      this.naPanelTarget.classList.add("hidden")
    } else {
      this.checkboxTarget.checked = false
      this.naPanelTarget.classList.remove("hidden")
      this.naReasonTarget.focus()

      if (this.naReasonTarget.value.trim() !== "") {
        this.patchItem({
          "qc_checklist_item[not_applicable]": "1",
          "qc_checklist_item[na_reason]": this.naReasonTarget.value,
          "qc_checklist_item[checked]": this.checkboxTarget.checked ? "1" : "0"
        })
      }
    }
  }

  toggleNote(event) {
    event.preventDefault()
    this.notePanelTarget.classList.toggle("hidden")
    if (!this.notePanelTarget.classList.contains("hidden")) {
      this.noteTarget.focus()
    }
  }

  saveNaReason() {
    if (this.naReasonTarget.value.trim() !== "") {
      this.patchItem({
        "qc_checklist_item[not_applicable]": "1",
        "qc_checklist_item[na_reason]": this.naReasonTarget.value,
        "qc_checklist_item[checked]": "0"
      })
    } else {
      this.patchItem({
        "qc_checklist_item[not_applicable]": "0",
        "qc_checklist_item[na_reason]": this.naReasonTarget.value,
        "qc_checklist_item[checked]": "0"
      })
    }
  }

  saveNote() {
    this.patchItem({
      "qc_checklist_item[note]": this.noteTarget.value
    })
  }

  patchItem(body) {
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams(body)
    })
      .then(response => {
        if (!response.ok) throw new Error("Update failed")
        return response.text()
      })
      .then(html => Turbo.renderStreamMessage(html))
      .catch(() => {})
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
